module.exports = __webpack_public_path__ + "static/media/cbs-tv-ncis2.fe7f8a33.png";